import { useQuery } from "@tanstack/react-query";
import { hubFetch } from "../lib/auth.js";

/** 拉取指定 package version 的 SKILL.md 内容(upload 时解压存下来的) */
export function useSkillMd(name: string | undefined, version: string | undefined) {
  return useQuery({
    queryKey: ["admin", "skill-md", name, version],
    queryFn: async () => {
      if (!name || !version) return null;
      try {
        const res = await hubFetch<{ content: string }>(
          `/admin/packages/${encodeURIComponent(name)}/versions/${encodeURIComponent(version)}/skill-md`,
        );
        return res.content;
      } catch (err) {
        // 404 算正常(该版本没提供 SKILL.md),上层显示空态
        if ((err as Error).message.includes("404")) return null;
        throw err;
      }
    },
    enabled: !!name && !!version,
    staleTime: 60_000,
  });
}
